export default __webpack_public_path__ + "static/media/crew-02.4e7c321c.svg";